'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.weeksUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/weeksUntil.js
// module id = 612
// module chunks = 0